"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var prop_types_1 = __importDefault(require("prop-types"));
var react_1 = __importStar(require("react"));
var draftail_1 = require("draftail");
var Tooltip_1 = __importDefault(require("../Tooltip/Tooltip"));
var Portal_1 = __importDefault(require("../../Portal/Portal"));
var draft_js_1 = require("draft-js");
// Constraints the maximum size of the tooltip.
var OPTIONS_MAX_WIDTH = 300;
var OPTIONS_SPACING = 70;
var TOOLTIP_MAX_WIDTH = OPTIONS_MAX_WIDTH + OPTIONS_SPACING;
/**
 * Editor block to preview and edit images.
 */
var MediaBlock = /** @class */ (function (_super) {
    __extends(MediaBlock, _super);
    function MediaBlock(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            showTooltipAt: null,
        };
        _this.onClick = _this.onClick.bind(_this);
        _this.selectCurrentBlock = _this.selectCurrentBlock.bind(_this);
        _this.openTooltip = _this.openTooltip.bind(_this);
        _this.closeTooltip = _this.closeTooltip.bind(_this);
        _this.renderTooltip = _this.renderTooltip.bind(_this);
        return _this;
    }
    MediaBlock.prototype.onClick = function (e) {
        var trigger = e.target.closest('[data-draftail-trigger]');
        // Click is within the tooltip.
        if (!trigger) {
            return;
        }
        this.selectCurrentBlock();
        this.openTooltip(trigger);
    };
    MediaBlock.prototype.selectCurrentBlock = function () {
        var _a = this.props, block = _a.block, blockProps = _a.blockProps;
        var editorState = blockProps.editorState, onChange = blockProps.onChange;
        var selection = new draft_js_1.SelectionState({
            anchorKey: block.getKey(),
            anchorOffset: 0,
            focusKey: block.getKey(),
            focusOffset: block.getLength(),
            hasFocus: true,
        });
        onChange(draft_js_1.EditorState.forceSelection(editorState, selection));
    };
    MediaBlock.prototype.openTooltip = function (trigger) {
        var container = trigger.closest('[data-draftail-editor-wrapper]');
        var containerRect = container.getBoundingClientRect();
        var rect = trigger.getBoundingClientRect();
        var maxWidth = trigger.parentNode.offsetWidth - rect.width;
        this.setState({
            showTooltipAt: {
                container: container,
                top: rect.top - containerRect.top - (document.documentElement.scrollTop || document.body.scrollTop),
                left: rect.left - containerRect.left - (document.documentElement.scrollLeft || document.body.scrollLeft),
                width: rect.width,
                height: rect.height,
                direction: maxWidth >= TOOLTIP_MAX_WIDTH ? 'left' : 'top-left',
            },
        });
    };
    MediaBlock.prototype.closeTooltip = function () {
        this.setState({ showTooltipAt: null });
    };
    MediaBlock.prototype.renderTooltip = function () {
        var children = this.props.children;
        var showTooltipAt = this.state.showTooltipAt;
        return (react_1["default"].createElement(Portal_1["default"], { node: showTooltipAt.container, onClose: this.closeTooltip, closeOnClick: true, closeOnType: true, closeOnResize: true },
            react_1["default"].createElement(Tooltip_1["default"], { target: showTooltipAt, direction: showTooltipAt.direction },
                react_1["default"].createElement("div", { style: { maxWidth: OPTIONS_MAX_WIDTH } }, children))));
    };
    MediaBlock.prototype.render = function () {
        var _a = this.props, blockProps = _a.blockProps, src = _a.src, alt = _a.alt;
        var showTooltipAt = this.state.showTooltipAt;
        var entityType = blockProps.entityType;
        return (react_1["default"].createElement("button", { type: "button", tabIndex: -1, className: "MediaBlock", onClick: this.onClick, "data-draftail-trigger": true },
            react_1["default"].createElement("span", { className: "MediaBlock__icon-wrapper", "aria-hidden": true },
                react_1["default"].createElement(draftail_1.Icon, { icon: entityType.icon, className: "MediaBlock__icon" })),
            react_1["default"].createElement("img", { className: "MediaBlock__img", src: src, alt: alt, width: "256" }),
            showTooltipAt && this.renderTooltip()));
    };
    return MediaBlock;
}(react_1.Component));
MediaBlock.propTypes = {
    blockProps: prop_types_1["default"].shape({
        entityType: prop_types_1["default"].object.isRequired,
        editorState: prop_types_1["default"].object.isRequired,
        onChange: prop_types_1["default"].func.isRequired,
    }).isRequired,
    block: prop_types_1["default"].object.isRequired,
    src: prop_types_1["default"].string,
    alt: prop_types_1["default"].string,
    children: prop_types_1["default"].node.isRequired,
};
MediaBlock.defaultProps = {
    src: null,
    alt: '',
};
exports["default"] = MediaBlock;
